import { Coupon, IPagination, LogIn, Order, User } from 'src/app/interfaces';

export interface AuthStateModel {
    token: string | null;
    refreshToken: string | null;
    pbToken: string | null;
    displayAuthWidget: boolean;
    syncAll: boolean;
    syncUpdates: boolean;
    syncLandingPage: boolean;
    activateLandingPage: boolean;
    profile: User;
    orders: Order[];
    coupons: Coupon[];
    ordersPagination: IPagination;
}

export class Login {
    static readonly type = '[Auth] Login';
    constructor(public payload: LogIn) {}
}

export class Register {
    static readonly type = '[Auth] Register';
    constructor(public payload: User) {}
}

export class Logout {
    static readonly type = '[Auth] Logout';
}
export class ResetAllTokens {
    static readonly type = '[Auth] Reset all tokens';
}

export class DeleteAccount {
    static readonly type = '[Auth] Delete account';
}

export class HideAuthWidget {
    static readonly type = '[Auth] Hide auth widget';
}

export class SyncAllProducts {
    static readonly type = '[Auth] Sync all products';
}

export class SyncAllUpdates {
    static readonly type = '[Auth] Sync all updated products';
}

export class SyncLandingPage {
    static readonly type = '[Auth] Sync landing page';
}

export class ActivateLandingPage {
    static readonly type = '[Auth] Activate landing page';
}

export class GetPublicToken {
    static readonly type = '[Auth] Get public access token';
    constructor(public deviceId: string) {}
}

export class GetUserProfile {
    static readonly type = '[Auth] Get user profile';
}

export class AddProfileAddress {
    static readonly type = '[Auth] Add address';
    constructor(public payload: any) {}
}

export class RemoveProfileAddress {
    static readonly type = '[Auth] Remove address';
    constructor(public payload: any) {}
}

export class GetMyOrders {
    static readonly type = '[Auth] Get my orders';
}

export class GetMyCoupons {
    static readonly type = '[Auth] Get my coupons';
}
export class RequestAccountData {
    static readonly type = '[Auth] Request account data';
}
// TODO - @Paul, on server, please only save the token, do not subscribe to topic
// From client - Notify server on subscribe and unsubscribe
export class PushNotificationRegister {
    static readonly type = '[Auth] Register push notification device';
    constructor(public payload: string) {}
}
export class SubscribeToPushTopic {
    static readonly type = '[Auth] Subscribe to push token';
}
export class UnsubscribeFromPushTopic {
    static readonly type = '[Auth] Unsibscribe from push topic';
}
